import script from "./searchjob.vue?vue&type=script&setup=true&lang=js"
export * from "./searchjob.vue?vue&type=script&setup=true&lang=js"

import "./searchjob.vue?vue&type=style&index=0&id=f40ac098&scoped=true&lang=css"

import exportComponent from "D:\\project\\97job-wechat\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f40ac098"]])

export default __exports__